// Como o GET /players/me pode falhar, classificado pra store decidir o que
// fazer — mesmo desenho do RouletteSpinError/DailyCheckinClaimError.
//
// Desde que o core passou a INTROSPECTAR o token do jogador na Cactus
// (EnsurePlayerTokenIdentity), a rota deixou de falhar num jeito só:
//
// - 'unauthenticated' (401): a Cactus NÃO reconhece o token — sessão morta,
//   ou token que não é dono do `user_id` enviado. Antes qualquer Bearer
//   passava; agora este é um veredito sobre a sessão do jogador.
// - 'unavailable' (503 `token_verification_unavailable`): o core não conseguiu
//   perguntar à Cactus (fora, timeout de 2s, cooldown de 10s, brand sem
//   credencial). Fail-closed sem fallback, por decisão deles. Transitório.
// - 'network': timeout do front ou queda de rede.
// - 'api': qualquer outro status.
export type PlayerProfileErrorKind =
  | 'unauthenticated'
  | 'unavailable'
  | 'network'
  | 'api';

export class PlayerProfileError extends Error {
  constructor(
    public readonly kind: PlayerProfileErrorKind,
    message?: string,
  ) {
    super(message ?? kind);
    this.name = 'PlayerProfileError';
  }
}

export function classifyPlayerProfileError(
  status: number,
  code: unknown,
): PlayerProfileErrorKind {
  if (status === 401) return 'unauthenticated';
  if (status === 503 && code === 'token_verification_unavailable')
    return 'unavailable';

  return 'api';
}
